import i18n from '@/utils/i18n';
import React from 'react';
import { createStyles } from '@/contexts/theme-context';
import { FONTS } from '@/styles';
import { getPaymentHistoryStatus } from './payment-history-utils';
import { PaymentBatchStatus } from '@/enums';
import { Text, View } from 'react-native';

interface Props {
  createdAt: Date;
  status: PaymentBatchStatus;
}

export const PaymentStatusCard: React.FC<Props> = ({ createdAt, status }) => {
  const [styles, theme] = useStyles();
  const { secondaryStatusColor, secondaryStatusText, statusColor, statusText } =
    getPaymentHistoryStatus(createdAt, status, theme);

  return (
    <View style={styles.flexRow}>
      <Text style={[styles.statusText, { color: statusColor }]}>
        {i18n.t(statusText)}
      </Text>
      {secondaryStatusText && secondaryStatusColor ? (
        <Text
          style={[styles.secondaryStatusText, { color: secondaryStatusColor }]}
        >
          {i18n.t(secondaryStatusText)}
        </Text>
      ) : null}
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  flexRow: {
    alignItems: 'center',
    flexDirection: 'row',
  },
  secondaryStatusText: {
    ...FONTS.primary,
    fontSize: theme.fontSizes.xsmall,
    marginLeft: 8,
  },
  statusText: {
    ...FONTS.primaryBold,
    textTransform: 'uppercase',
  },
}));
